<template>
  <Authenticated>
    <div class="xero-page">
      <div class="xero-header">
        <h1 class="page-title">Xero Settings</h1>
        <div class="actions">
          <button v-if="!companySettings.xero_linked" @click="connectToXero">Connect to Xero</button>
          <button v-else @click="openConfirm = true">Disconnect from Xero</button>
        </div>
      </div>

      <div class="cards">
        <section class="card">
          <header class="card-header">
            <h2>Organisation</h2>
            <div class="actions">
              <button @click="getOrgDetails">Fetch Details</button>
            </div>
          </header>
          <div class="card-body">
            <pre v-if="orgDetails">{{ orgDetails }}</pre>
            <p v-else>No organisation details loaded.</p>
          </div>
        </section>

        <section class="card">
          <header class="card-header">
            <h2>Bank Transactions</h2>
            <div class="actions">
              <button @click="getBankTransactions">Fetch Transactions</button>
            </div>
          </header>
          <div class="card-body">
            <pre v-if="transactions">{{ transactions }}</pre>
            <p v-else>No transactions loaded.</p>
          </div>
        </section>

        <section class="card">
          <header class="card-header">
            <h2>Profit &amp; Loss</h2>
            <div class="actions">
              <button @click="getProfitAndLoss">Fetch Report</button>
            </div>
          </header>
          <div class="card-body">
            <pre v-if="profitAndLoss">{{ profitAndLoss }}</pre>
            <p v-else>No profit and loss report loaded.</p>
          </div>
        </section>
      </div>
    </div>
    <Confirm :open="openConfirm" message="Are you sure you want to disconnect from Xero" @confirmModal="disconnectFromXero" />
  </Authenticated>
</template>

<script>
import Authenticated from "@/components/_layouts/Authenticated.vue";
import Confirm from "@monolith/components";
import { api } from "@monolith/helpers";
import { mapGetters } from "vuex";

export default {
  name: "XeroPage",
  components: {
    Authenticated,
    Confirm,
  },

  data() {
    return {
      orgDetails: null,
      transactions: null,
      profitAndLoss: null,
      openConfirm: false,
    };
  },

  mounted() {},

  computed: {
    ...mapGetters({
      companySettings: "companySettings",
      siteSettings: "siteSettings",
    }),

  },

  methods: {
    async getOrgDetails() {
      this.orgDetails = await api.get_xero_organisation_details();
    },

    async getBankTransactions() {
      this.transactions = await api.get_xero_bank_transactions();
    },

    async getProfitAndLoss() {
      this.profitAndLoss = await api.get_xero_profit_and_loss();
    },

    async connectToXero() {
      let result = await api.integrate_with_xero();
      window.location.href = result.url;
    },

    async disconnectFromXero() {
      this.openConfirm = false;
    },
  },
};
</script>

<style scoped>
.xero-page {
  padding: 24px;
}

.xero-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
  flex-wrap: wrap;
}

.page-title {
  margin: 0 0 16px;
  line-height: 1.2;
}

.cards {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
}

.card {
  background-color: var(--primary-colour);
  box-shadow: var(--box-shadow);
  border-radius: 1rem;
}

.actions button {
  background-color: var(--action-colour);
  color: var(--text-colour);
  border: none;
  padding: 1rem;
  border-radius: 0.5rem;
  box-shadow: var(--box-shadow);
  cursor: pointer;
}

.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 2rem;
}

.card-body {
  padding: 1rem 2rem;
}

.card-body pre {
  margin: 0;
  white-space: pre-wrap;
  word-break: break-word;
}

@media (min-width: 720px) {
  .cards {
    grid-template-columns: 1fr 1fr;
  }
}
</style>
